import React from 'react';

export const AuthContext = React.createContext({});
export const AuthProvider = AuthContext.Provider;
export const AuthConsumer = AuthContext.Consumer;


// WEBPACK FOOTER //
// ./src/components/Auth/AuthContext.jsx